import { createFileRoute } from '@tanstack/react-router';

import { FEATURE_FLAGS } from 'shared/consts';
import { routes } from 'shared/routes';
import { requireFeatureFlag } from 'shared/utils';

import { GbpInsights } from 'features/reports/GbpInsights';

export const Route = createFileRoute('/_authenticated/locations/$id/_shell/gbp/insights')({
  staticData: { breadcrumb: 'gbpInsights' },
  beforeLoad: ({ context }) =>
    requireFeatureFlag(FEATURE_FLAGS.GBP_INSIGHTS_ALLOWED, context.authUser.featureAllowance, {
      fallbackRoute: routes.locations()
    }),
  component: GbpInsights
});
